import React from "react";
import { MenuItem, SelectProps, Select, styled } from "@mui/material";

export interface SelectTextInputInterface extends SelectProps {
  value?: string;
  placeholder?: string;
  roundedCorners?: boolean;
  options: { label: string; value: string }[];
}

const StyledSelectInput = styled(Select, {
  shouldForwardProp: (prop) =>
    prop !== "roundCorners" && prop !== "isPlaceholder",
  name: "Select",
})<{ roundCorners?: boolean; isPlaceholder?: boolean; theme?: any }>(
  ({ roundCorners = true, isPlaceholder, theme }) => ({
    border: roundCorners ? `1px solid ${theme.palette.common.borderGrey}` : 0,
    fontWeight: 400,
    fontSize: 14,
    borderRadius: roundCorners ? 15 : 0,
    background: theme.palette.common.white,
    "& .MuiSelect-select": {
      padding: `8px 14px`,
      "&:focus": {
        background: "none",
      },
    },
    "& .MuiInput-input": {
      "-webkit-text-fill-color": isPlaceholder
        ? "rgba(18, 18, 18, 0.5) !important"
        : theme.palette.common.black,
    },
  })
);

const SelectInput = ({
  value = "",
  placeholder,
  roundedCorners = true,
  options,
  ...props
}: SelectTextInputInterface) => {
  const DropDownIcon = ({ className }: { className: string }) => {
    return (
      <i
        className={`font-black fas fa-angle-${
          className.indexOf("MuiSelect-iconOpen") >= 0 ? "up" : "down"
        }`}
        style={{
          position: "absolute",
          right: 10,
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: "0.75rem",
          fontWeight: 400,
        }}
      />
    );
  };

  return (
    <StyledSelectInput
      {...props}
      value={value}
      variant="standard"
      IconComponent={DropDownIcon}
      displayEmpty
      color="primary"
      roundCorners={roundedCorners}
      isPlaceholder={value === ""}
    >
      {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
      {options.map((option: { label: string; value: string }) => (
        <MenuItem value={option.value}>{option.label}</MenuItem>
      ))}
    </StyledSelectInput>
  );
};

export default SelectInput;
